import { Injectable } from '@angular/core';
import {SummaryPage} from '../models/summary-page';
import {Region} from '../models/region';
import {ActivatedRoute, Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(private route: ActivatedRoute,
              private router: Router) { }

  public groupByProduct(summaryPageArray: Array<SummaryPage>): Array<SummaryPage> {
    const labelGroups = this.buildLabelGroups(summaryPageArray);
    const updatedSubpages: Array<SummaryPage> = [];
    let regionsArray: Array<Region> = [];
    labelGroups.forEach(label => {
      regionsArray = [];
      let regionIndexCounter = 0;
      // build regions array
      summaryPageArray.forEach(page => {
        if (label === page.label) {
          const newRegion = new Region();
          newRegion.name = page.region;
          newRegion.statusPageUrl = page.statusPageUrl;
          newRegion.statusDescription = page.status;
          newRegion.index = regionIndexCounter;
          regionsArray.push(newRegion);
          regionIndexCounter++;
        }
      });
      // attach regions array to first instance of each product
      let first = true;
      summaryPageArray.forEach((page) => {
        if (label === page.label && first) {
          page.availableRegions = regionsArray;
          updatedSubpages.push(page);
          first = false;
        }
      });
    });
    return updatedSubpages;
  }

  private buildLabelGroups(summaryPageArray: Array<SummaryPage>): Array<string> {
    const labelGroups: Array<string> = [];
    summaryPageArray.forEach((page: SummaryPage) => {
      if (!labelGroups.includes(page.label)) {
        labelGroups.push(page.label);
      }
    });
    return labelGroups;
  }

  passDataToUrlParam(tabIndexNumber: number, regionName: string): Promise<any> {
    return this.router.navigate(
      ['.'],
      {
        relativeTo: this.route,
        queryParams: {
          tabIndex: tabIndexNumber,
          region: regionName
        },
        queryParamsHandling: 'merge',
      }
    );
  }
}
